
import React from "react";
import "../../styles/PrimaryBTN.css";
import { withNamespaces } from 'react-i18next';

const CarouselBtn = (props) => {
  return (
    <div className="text-start">
      <button className="learn-more_carousel">
        <a href={props.link} title={props.tilte}>
          <span className="circle_carousel" aria-hidden="true">
            <span className="icon arrow carousel"></span>
          </span>
          <span className="button-text_carousel">{props.texto}</span>
        </a>
      </button>
    </div>
  );
};

export default withNamespaces() (CarouselBtn);

